/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Camera_PermissionInputs */

const th_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อกล้องจะแสดงหลังจากคุณอนุญาตให้เข้าถึง`)
};

const en_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera names appear after you allow access.`)
};

const ja_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクセスを許可するとカメラ名が表示されます。`)
};

const zh_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`允许访问后会显示摄像头名称。`)
};

const es_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los nombres de las cámaras aparecen cuando permites el acceso.`)
};

const pt_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os nomes das câmeras aparecem depois que você permitir o acesso.`)
};

const id_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama kamera muncul setelah Anda mengizinkan akses.`)
};

const fr_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le nom des caméras apparaît une fois l’accès autorisé.`)
};

const tl_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lilitaw ang pangalan ng camera pagkatapos mong payagan ang paggamit.`)
};

const vi_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên máy ảnh hiện ra sau khi bạn cho phép truy cập.`)
};

const ko_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`접근을 허용하면 카메라 이름이 표시됩니다.`)
};

const de_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kameranamen erscheinen, sobald du den Zugriff erlaubst.`)
};

const ru_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Названия камер появятся после того, как вы разрешите доступ.`)
};

const tr_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erişime izin verdiğinizde kamera adları görünür.`)
};

const it_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I nomi delle fotocamere compaiono dopo che avrai consentito l'accesso.`)
};

const pl_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nazwy kamer pojawią się, gdy zezwolisz na dostęp.`)
};

const uk_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назви камер з'являться, коли ви дозволите доступ.`)
};

const hi_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहुँच की अनुमति देने पर कैमरों के नाम दिखेंगे।`)
};

const ar_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تظهر أسماء الكاميرات بعد أن تسمح بالوصول.`)
};

const ms_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama kamera muncul selepas anda membenarkan akses.`)
};

const bn_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অনুমতি দিলে ক্যামেরার নাম দেখা যাবে।`)
};

const zh_tw2_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`允許存取後會顯示相機名稱。`)
};

const zh_hk2_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`允許存取後會顯示相機名稱。`)
};

const ur_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رسائی کی اجازت دینے پر کیمروں کے نام دکھائی دیں گے۔`)
};

const fa_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نام دوربین‌ها پس از اجازهٔ دسترسی دیده می‌شود.`)
};

const sw_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Majina ya kamera yataonekana baada ya kuruhusu ufikiaji.`)
};

const nl_video_camera_permission = /** @type {(inputs: Video_Camera_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cameranamen verschijnen zodra je toegang hebt gegeven.`)
};

/**
* | output |
* | --- |
* | "Camera names appear after you allow access." |
*
* @param {Video_Camera_PermissionInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_camera_permission = /** @type {((inputs?: Video_Camera_PermissionInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Camera_PermissionInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_camera_permission(inputs)
	if (locale === "ja") return ja_video_camera_permission(inputs)
	if (locale === "zh") return zh_video_camera_permission(inputs)
	if (locale === "es") return es_video_camera_permission(inputs)
	if (locale === "pt") return pt_video_camera_permission(inputs)
	if (locale === "id") return id_video_camera_permission(inputs)
	if (locale === "fr") return fr_video_camera_permission(inputs)
	if (locale === "tl") return tl_video_camera_permission(inputs)
	if (locale === "vi") return vi_video_camera_permission(inputs)
	if (locale === "ko") return ko_video_camera_permission(inputs)
	if (locale === "de") return de_video_camera_permission(inputs)
	if (locale === "ru") return ru_video_camera_permission(inputs)
	if (locale === "tr") return tr_video_camera_permission(inputs)
	if (locale === "it") return it_video_camera_permission(inputs)
	if (locale === "pl") return pl_video_camera_permission(inputs)
	if (locale === "uk") return uk_video_camera_permission(inputs)
	if (locale === "hi") return hi_video_camera_permission(inputs)
	if (locale === "ar") return ar_video_camera_permission(inputs)
	if (locale === "ms") return ms_video_camera_permission(inputs)
	if (locale === "bn") return bn_video_camera_permission(inputs)
	if (locale === "zh-TW") return zh_tw2_video_camera_permission(inputs)
	if (locale === "zh-HK") return zh_hk2_video_camera_permission(inputs)
	if (locale === "ur") return ur_video_camera_permission(inputs)
	if (locale === "fa") return fa_video_camera_permission(inputs)
	if (locale === "sw") return sw_video_camera_permission(inputs)
	if (locale === "nl") return nl_video_camera_permission(inputs)
	return en_video_camera_permission(inputs)
});